import React from "react";
import { Star, ExternalLink } from "lucide-react";
import { YELP_URL } from "../../lib/content";

export default function Reviews({ t }) {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="bg-white border-t border-brand py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div className="max-w-2xl">
          <span className="section-tag" data-testid="reviews-tag">
            {t.reviews.tag}
          </span>
          <h2
            data-testid="reviews-title"
            className="font-display font-black text-brand-primary text-3xl sm:text-4xl tracking-tighter mt-4 leading-[1.05]"
          >
            {t.reviews.title}
          </h2>
          <p className="mt-4 text-base md:text-lg text-brand-muted leading-relaxed">
            {t.reviews.copy}
          </p>
        </div>
        <a
          href={YELP_URL}
          target="_blank"
          rel="noopener noreferrer nofollow"
          data-testid="reviews-yelp-cta"
          className="btn-primary text-base md:text-lg w-full md:w-auto flex-shrink-0"
        >
          <Star className="w-5 h-5" strokeWidth={2.5} />
          {t.reviews.cta}
          <ExternalLink className="w-4 h-4" strokeWidth={2.5} />
        </a>
      </div>
    </section>
  );
}
